Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var coreComponentsBaseModal = require('../../base-modal');
var components_content_Component_mobile = require('../components/content/Component.mobile.js');
var components_controls_Component = require('../components/controls/Component.js');
var components_footer_Component_mobile = require('../components/footer/Component.mobile.js');
var components_header_Component = require('../components/header/Component.js');
var ResponsiveContext = require('../ResponsiveContext.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"component":"side-panel__component_1s7zy","mobileContent":"side-panel__mobileContent_1s7zy"};
require('./mobile.css');

var transitions = {"appear":"side-panel__appear_2oxdh","enter":"side-panel__enter_2oxdh","appearActive":"side-panel__appearActive_2oxdh","enterActive":"side-panel__enterActive_2oxdh","exit":"side-panel__exit_2oxdh","exitActive":"side-panel__exitActive_2oxdh","exitDone":"side-panel__exitDone_2oxdh"};
require('./transitions.mobile.css');

var SidePanelMobileComponent = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, transitionProps = _a.transitionProps, dataTestId = _a.dataTestId, restProps = tslib.__rest(_a, ["children", "className", "transitionProps", "dataTestId"]);
    var responsiveContext = React.useContext(ResponsiveContext.ResponsiveContext);
    var contextValue = React.useMemo(function () { return ({ size: 500, view: 'mobile', dataTestId: dataTestId }); }, [dataTestId]);
    var renderContent = function () { return (React__default.default.createElement(coreComponentsBaseModal.BaseModal, tslib.__assign({}, restProps, { dataTestId: dataTestId, ref: ref, transitionProps: tslib.__assign({ classNames: transitions }, transitionProps), className: cn__default.default(className, styles.component), scrollHandler: 'content' }),
        React__default.default.createElement("div", { className: styles.mobileContent }, children))); };
    var renderWithContext = function () { return (React__default.default.createElement(ResponsiveContext.ResponsiveContext.Provider, { value: contextValue }, renderContent())); };
    return responsiveContext ? renderContent() : renderWithContext();
});
var SidePanelMobile = Object.assign(SidePanelMobileComponent, {
    Content: components_content_Component_mobile.ContentMobile,
    Header: components_header_Component.Header,
    Footer: components_footer_Component_mobile.FooterMobile,
    Controls: components_controls_Component.Controls,
});

exports.SidePanelMobile = SidePanelMobile;
